import { render, staticRenderFns } from "./InspectionPage.vue?vue&type=template&id=76fba9c1&"
import script from "./InspectionPage.vue?vue&type=script&lang=js&"
export * from "./InspectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports